<template>
  <TheDashboard :user="user">
    <template #logout-btn>
      <ClientLogoutBtn />
    </template>
    <template #sidebar="{ vOnNavigate, vOnClose, ...attrs }">
      <DashboardAdminSidebar v-bind="attrs" @navigate="vOnNavigate" @close="vOnClose" />
    </template>
    <slot />
  </TheDashboard>
</template>

<script lang="ts" setup>
  // Types
  import type { TAuthStore } from '~/modules/auth/store/types';
  import type { TUser } from '~/misc/auth/types';

  // Store
  import { useAuthStore } from '~/modules/auth/store';

  // Components
  import TheDashboard from '~/modules/dashboard/TheDashboard.vue';
  import ClientLogoutBtn from '~/modules/auth/client-logout-btn/ClientLogoutBtn.vue';
  import DashboardAdminSidebar from '~/modules/dashboard/admin/sidebar/DashboardAdminSidebar.vue';

  const authStore: TAuthStore = useAuthStore();

  const user: ComputedRef<TUser | null> = computed<TUser | null>(() => authStore.user);
</script>
